const KEY = "__upsideEarlySocket";
const UNTAKEN_CLOSE_MS = 8_000;

type Handoff = { readonly socket: WebSocket; readonly url: string };

const inline = (value: unknown) => JSON.stringify(value).replace(/</g, "\\u003c");

export function earlySocketScript(streamUrl: string): string {
  const url = inline(streamUrl);
  return `(function(){if(document.hidden)return;try{var s=new WebSocket(${url});window.${KEY}={socket:s,url:${url}};setTimeout(function(){var h=window.${KEY};if(h&&h.socket===s){delete window.${KEY};s.close()}},${UNTAKEN_CLOSE_MS})}catch(e){}})()`;
}

export function takeEarlySocket(streamUrl: string): WebSocket | null {
  const scope = globalThis as { [KEY]?: Handoff };
  const handoff = scope[KEY];
  delete scope[KEY];
  if (handoff === undefined) return null;
  if (handoff.url === streamUrl && handoff.socket.readyState <= WebSocket.OPEN) return handoff.socket;
  handoff.socket.close();
  return null;
}
